<template>
  <section class="menu-link-grid">
    <div
      class="grid-inner"
      :style="{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }"
    >
      <div
        v-for="(item, index) in items"
        :key="index"
        class="grid-card"
        :style="{ '--accent': item.accent || '#2563eb' }"
        @mouseenter="hovered = index"
        @mouseleave="hovered = null"
      >
        <router-link :to="item.to" class="card-link">
          <div class="card-index">{{ String(index + 1).padStart(2, '0') }}</div>
          <div class="card-body">
            <p class="card-sub">{{ item.sub }}</p>
            <h2 class="card-title">{{ item.title }}</h2>
            <p class="card-desc">{{ item.desc }}</p>
          </div>
          <div class="card-arrow">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M4 10H16M16 10L11 5M16 10L11 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="card-bar"></div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MenuLinkGrid',
  props: {
    items: {
      type: Array,
      required: true
      // 각 item: { title, sub, desc, to, accent(optional) }
    }
  },
  data () {
    return { hovered: null }
  }
}
</script>

<style scoped>
</style>
